import css from "styled-jsx/css";

export const componentStyles = css.global`
  .structured-header-menu-content {
    padding-left: 64px;
    .header-menu-sections-wrapper {
      display: flex;
      .header-menu-section-title {
        font-size: 1rem;
      }
      .header-menu-section-item-component-wrapper {
        &.story {
          &:hover {
            filter: drop-shadow(0px 8px 24px rgba(29, 140, 242, 0.08));
          }
        }
      }
    }
  }
`;
